import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { loginUser } from '../api/authApi';
import { getLoginReasonMessage } from '../utils/adminAuthFailure';
import './AuthPage.css';

const LoginPage = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(() => getLoginReasonMessage(location.search));
    const [isLoading, setIsLoading] = useState(false);
    const redirectTo = (location.state as any)?.redirectTo || '/';

    const handleLogin = async () => {
        if(!email.trim() || !password) {
            setError('모든 항목을 입력하세요.');
            return;
        }

        setError('');
        setIsLoading(true);
        try {
            const response = await loginUser(email.trim(), password);
            if(!response.data.success) {
                setError(response.data.message);
                return;
            }

            localStorage.setItem('token', response.data.token);
            localStorage.setItem('role', response.data.role);
            localStorage.setItem('nickname', response.data.nickname);
            localStorage.setItem('userId', response.data.userId);
            navigate(redirectTo);
        } catch (requestError) {
            console.error(requestError);
            setError('로그인에 실패했어요. 이메일과 비밀번호를 확인해주세요.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <main className="login-page auth-page">
            <section className="auth-intro" aria-labelledby="login-heading">
                <p className="login-label">계정</p>
                <h1 id="login-heading" className="login-title">다시 판단의 자리로.</h1>
                <p>내가 고른 진실과 참여한 토론을 이어서 확인하세요.</p>
            </section>

            <form
                className="login-card auth-form"
                onSubmit={(event) => {
                    event.preventDefault();
                    handleLogin();
                }}
            >
                <div className="auth-field">
                    <label htmlFor="login-email">이메일</label>
                    <input
                        id="login-email"
                        type="email"
                        autoComplete="email"
                        value={email}
                        onChange={(event) => setEmail(event.target.value)}
                        className="login-input"
                    />
                </div>

                <div className="auth-field">
                    <label htmlFor="login-password">비밀번호</label>
                    <input
                        id="login-password"
                        type="password"
                        autoComplete="current-password"
                        value={password}
                        onChange={(event) => setPassword(event.target.value)}
                        className="login-input"
                    />
                </div>

                {error && <p className="login-error" role="alert">{error}</p>}

                <button type="submit" className="login-button" disabled={isLoading}>
                    {isLoading ? '로그인 중…' : '로그인'}
                </button>

                <p className="signup-text-wrap">
                    <span className="signup-guide-text">계정이 없으신가요?</span>
                    <a className="signup-text-button" href="#/signup">회원가입</a>
                </p>
            </form>
        </main>
    );
};

export default LoginPage;
